<template lang="pug">
.form-tier.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.tier" autocomplete="ño" disabled required)
        label.label(:class="{ show: dataForm.tier }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="tier" title="Nivel")

      .input-container
        input.input(v-model="dataForm.name" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.name }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="name" title="Nombre")

      .input-container.arrow
        select.select(v-model="dataForm.warehouse" autocomplete="ño" required)
          option(v-for="warehouse in warehouses" :value="warehouse") {{ warehouse }}
        label.label(:class="{ show: dataForm.warehouse }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="warehouse" title="Bodega")

      .input-container.arrow
        select.select(v-model="dataForm.shelf" autocomplete="ño" required)
          option(v-for="shelf in shelfs" :value="shelf") {{ shelf }}
        label.label(:class="{ show: dataForm.shelf }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="shelf" title="Estante")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteTier")
</template>

<script>
import mDB from '@/mixins/db'
import mForm from '@/mixins/form'
import gqlTier from '@/graphql/tier'
import shDeleteButton from '@/components/elements/DeleteButton'
import shProperty from '@/components/elements/Property'
import gql from '@my/graphql'

export default {
  name: 'FormTier',

  mixins: [mDB, mForm],

  components: { shDeleteButton, shProperty },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        tier: '',
        name: '',
        warehouse: '',
        shelf: ''
      },
      resolver: 'tier',
      key: 'tier',
      gql: gqlTier
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  mounted () {
    if (!this.fillData) this.countTiers()
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newTier()
      } else {
        this.updateTier()
      }
    },

    newTier () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateTier () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteTier () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    async countTiers (options) {
      const query = gqlTier.COUNT

      const response = await gql.query(query)

      if (!response) {
        this.showMessage({
          message: 'Error to count tiers',
          title: 'No Reponse',
          type: 'error',
          show: true,
          function: false
        })
      } else {
        if (!response || !response.data || response.data.countTiers === undefined) {
          this.showMessage({
            message: 'Error to count tiers',
            title: 'No Reponse',
            type: 'error',
            show: true,
            function: false
          })
        } else {
          const count = response.data.countTiers
          this.dataForm.tier = `T${count + 1}`
          this.dataForm.name = `T${count + 1}`
        }
      }
    }
  },

  computed: {
    warehouses () {
      return this.$store.state.warehouses
    },
    shelfs () {
      return this.$store.state.shelfs
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-tier
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/tier/Form.vue